import { Box, Button, Flex, Stack } from "@chakra-ui/react";
import { Text, Image, Link } from "../../components";
import { formatPriceToNaira, truncateText } from "../../utils";
import { Ratings } from "../../components";
import Rated from "../../layouts/user/Rated";
import { userGetCategoryListing } from "../../services";
import { useEffect } from "react";
import { useApp } from "../../contexts";
export const CourseProductCard = ({ course, listItem, w }) => {
  const appManager = useApp();
  const metadata = appManager.state.metadata;
  const catItems = metadata?.courseCategory;
  // const fetcher= async()=>{
  //   const {categories}=await userGetCategoryListing()
  //   console.log(categories);
  // }
  // useEffect(()=>{
  //    fetcher()
  // }, [])
  const renderContent = () => (
    <Box pos={"relative"}>
      <Text
        isTruncated={listItem ? false : true}
        bold
        mb={1}
        _hover={{
          textDecoration: "underline",
        }}
      >
        <a href={`/general/courses/${course.id}`}>{listItem && course.title}</a>
      </Text>
      {course.description && (
        <Text mb={1}>{truncateText(course.description, 150)}</Text>
      )}

      {/* {course.instructor && (
        <Box w="fit-content">
          <Link href={`/users/${course.instructor.id}`}>
            <Flex
              alignItems="center"
              _hover={{
                textDecoration: "underline",
              }}
            > */}
      {/*<Image*/}
      {/*  src={course.instructor.photo}*/}
      {/*  alt={course.instructor.name}*/}
      {/*  height={{ base: "30px", tablet: "30px" }}*/}
      {/*  width={{ base: "30px", tablet: "30px" }}*/}
      {/*  flexShrink={0}*/}
      {/*  rounded="full"*/}
      {/*  mr={2}*/}
      {/*/>*/}

      {/* <Text opacity={0.8} isTruncated>
                {course.instructor.name}
              </Text>
            </Flex>
          </Link>
        </Box>
      )} */}

      <Box w="fit-content" mt={3}>
        {course.reviews.length === 0 ? (
          <Box
            _hover={{
              textDecoration: "underline",
            }}
          >
            <Link
              href={`/rev/${course.id}`}
              onClick={localStorage.setItem("course", course.id)}
            >
              <Text as="level4" bold mb={{ base: 1, tablet: 2 }}>
                Rate this course
              </Text>
            </Link>
          </Box>
        ) : (
          <Rated val={course.reviews?.map((rev) => rev.reviewerRating)} />
        )}
      </Box>

      <Flex alignItems="center" gridGap={5}>
        <Text bold as={course.description ? "level2" : "level3"}>
          {formatPriceToNaira(Number(course.price))}
        </Text>
      </Flex>
    </Box>
  );

  return (
    <Stack
      pos={"relative"}
      p={{ base: 1, tablet: 2 }}
      m={{ base: 1, tablet: 2 }}
      spacing={listItem ? 0 : 2}
      w={
        w ||
        (listItem
          ? "auto"
          : { base: "200px", tablet: "225px", laptop: "270px" })
      }
      //   maxW={listItem && { base: "200px", tablet: "400px", laptop: "700px" }}
      minH={!listItem && { base: "200px", laptop: "200px" }}
      bg="white"
      rounded="md"
      shadow="0px 4px 10px rgba(0, 0, 0, 0.25)"
      flexDirection={listItem ? "row" : "column"}
    >
      <Image
        src={course.image || course.thumbnailUrl}
        alt={course.title}
        w={course.description ? "100%" : listItem ? "290px" : "100%"}
        h={
          course.description
            ? "160px"
            : listItem
            ? ""
            : { base: "160px", tablet: "160px", laptop: "160px" }
        }
        rounded="md"
        flexShrink={0}
      />
      ){listItem ? <Stack pl={5}>{renderContent()}</Stack> : renderContent()}
      {catItems
        ?.filter((cat) => cat.id === course.categoryId)
        .map((cat) => (
          <div>
            <Button
              backgroundColor={"#5E0101"}
              outline={"2px solid #fff"}
              color={"#fff"}
              pos={"absolute"}
              top={"10"}
              left={6}
              _hover={{ backgroundColor: "green" }}
              borderRadius={7}
            >
              {truncateText(cat.categoryName, 12)}
            </Button>
          </div>
        ))}
    </Stack>
  );
};
